import {emotionStyled} from '@packages/utilities/styled';

export const ModalFooterView = emotionStyled('div')(
  {
    padding: '$3',
  },
  {
    componentName: 'ModalFooter',
    variants: {
      hasBorder: {
        true: {
          borderTop: '$border1',
        },
      },
    },
  }
);
